import { render, staticRenderFns } from "./pjnoticeInfo.vue?vue&type=template&id=9b91ea08&scoped=true&"
import script from "./pjnoticeInfo.vue?vue&type=script&lang=js&"
export * from "./pjnoticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./pjnoticeInfo.vue?vue&type=style&index=0&id=9b91ea08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b91ea08",
  null
  
)

export default component.exports